import { Box, Button, Center, Flex, FormErrorMessage, FormLabel, Input, Spinner, Textarea } from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import Select from 'react-select';
import { DataContext } from "../../../../state/DataContext/DataContext";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import FileUploader from '../../../Shared/FileUploader/FileUploader';
import ImageListViewer from '../../../Shared/FileListViewer/FileListViewer';

export default function AddTask(props: {
    Task?: any,
    key: any
    isEdit?: any,
    onClosefn?: any
}) {

    console.log(props.key)
    const { data, actions } = React.useContext(DataContext);
    const [isLoading, setIsLoading] = React.useState(false);
    const [fileArray, setFileArray] = React.useState([]);
    let { tenantID, JobID } = useParams<any>();

    React.useEffect(() => {
        if (props.isEdit) {
            setValue("TaskTitle", props.Task?.TaskTitle)
            setValue("TaskDescription", props.Task?.TaskDescription)
        }
    }, [])



    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();



    const AddTask = (formData, Files) => {
        var taskID = uuidv4();
        var payload = { ...formData, TaskID: taskID, TaskFiles: Files }
        actions.Task.AddTask(tenantID, JobID, taskID, payload).then(e => {
            toast.success(`Task was added succesfully!`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setValue("TaskTitle", "")
            setValue("TaskDescription", "")
            setIsLoading(false)
            props.onClosefn()

        })
    }

    const EditTask = (formData, Files) => {
        var payload = { ...formData, TaskFiles: Files }
        actions.Task.EditTask(tenantID, JobID, props.Task.TaskID, payload).then(e => {
            toast.success(`Task was editted succesfully!`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setIsLoading(false)
            props.onClosefn();
        }
        )
    }

    const onSubmit = formData => {
        setIsLoading(true)

        // Add
        if (!props.isEdit) {

            if (fileArray.length > 0) {
                var promises = fileArray.map(file => {
                    return actions.Storage.AddFileAndGetFileObject(file)
                })


                Promise.all(promises).then(function (Files) {
                    AddTask(formData, Files)
                })
            }
            else {
                AddTask(formData, [])
                setIsLoading(false)

            }
        } else {
            // EDIT
            if (fileArray.length > 0) {
                promises = fileArray.map(file => {
                    return actions.Storage.AddFileAndGetFileObject(file)
                })

                Promise.all(promises).then(function (Files) {
                    EditTask(formData, Files)
                })
            }
            else {
                EditTask(formData, [])
                setIsLoading(false)
            }
        }



    }

    // console.log(watch("example")); // watch input value by passing the name of it
    let inputStyle = {
        backgroundColor: "white",
        borderRadius: "0.5em",
        border: "1px solid #333"
    }
    return (
        <Box position="relative" >
            {isLoading ? <Center><Spinner /></Center> :
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box >
                        <FormLabel htmlFor="TaskTitle">Task Title</FormLabel>
                        <Input
                            id="TaskTitle"
                            {...inputStyle}
                            placeholder="Remove carpet before start of work"
                            {...register("TaskTitle", {
                                required: "This is required",
                                minLength: { value: 4, message: "Minimum length should be 4" }
                            })}
                        />
                        <FormErrorMessage>
                            {errors.TaskTitle && errors.TaskTitle.message}
                        </FormErrorMessage>
                    </Box>

                    <Box mt="2" >
                        <FormLabel htmlFor="TaskDescription">Task Description</FormLabel>
                        <Textarea
                            id="TaskDescription"
                            {...inputStyle}
                            placeholder="Remove carpet before start of work"
                            {...register("TaskDescription", {
                                minLength: { value: 0, message: "" }
                            })}
                        />
                        <FormErrorMessage>
                            {errors.TaskDescription && errors.TaskDescription.message}
                        </FormErrorMessage>
                    </Box>

                    <Box mt={2}>
                        <FormLabel htmlFor="AssignTo">Assign Task to</FormLabel>

                        <Select
                            style={{ zIndex: "999" }}
                            isMulti
                            name="AssignTo"
                            options={[
                                { value: 'All', label: 'All' },
                            ]}
                            className="basic-multi-select"
                            classNamePrefix="select"
                        />
                    </Box>

                    <ImageListViewer
                        isEdit
                        key={props.isEdit ? "edit" : "add"}
                        uniqueKey={props.Task?.TaskID}
                        setFileArray={setFileArray} //to delete pictures
                        fileArray={fileArray} //get existing files
                    />

                    <FileUploader registerName="TaskFiles" Files={props.Task?.TaskFiles} setFileArray={setFileArray} fileArray={fileArray} register={register} />

                    <Flex justifyContent="flex-end">
                        <Button type="submit" right="0" mt="4" colorScheme="green" >
                            {props.isEdit ? "Edit" : "Add"} Task
                        </Button>
                    </Flex>
                </form >
            }
        </Box >
    );
}